import { useSWR, useSWRMutation } from '@tiger/swr';
import API from 'utils/API';
import { ContactPersonItemFormutil, TrustedContactPersonDataItem } from './type';

export const useGetContactList = () =>
    useSWR<{
        items: TrustedContactPersonDataItem[];
        total: number;
    }>(API.CUSTOMER.contacts.getAndPostItem(), {
        dataChain: res => res.data
    });

export const useAddContact = () =>
    useSWRMutation(API.CUSTOMER.contacts.getAndPostItem(), (params: ContactPersonItemFormutil) =>
        API.CUSTOMER.contacts.getAndPostItem.post(params, {
            useJson: true
        })
    );

export const useEditContact = () =>
    useSWRMutation(API.CUSTOMER.contacts.editAndDeleteItem(), (params: TrustedContactPersonDataItem) =>
        API.CUSTOMER.contacts.editAndDeleteItem.put(
            params,
            {
                useJson: true
            },
            params.id
        )
    );

export const useDeleteContact = () =>
    useSWRMutation(API.CUSTOMER.contacts.editAndDeleteItem(), (id: number) =>
        API.CUSTOMER.contacts.editAndDeleteItem.delete(
            {
                useJson: true
            },
            id
        )
    );
